import {useEffect, useRef, useState} from "react";

const ANIM_MS = 500;

const useExpandCollapseLogic = (stepIndex, activeStepIndex) => {
  const [expanded, setExpanded] = useState(true);
  const [collapsing, setCollapsing] = useState(false);

  const timeoutRef = useRef(null);
  const activeStepRef = useRef(activeStepIndex);

  // keep latest active step in a ref for timeout guards
  useEffect(() => {
    activeStepRef.current = activeStepIndex;
  }, [activeStepIndex]);

  const clear = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const collapseRing = () => {
    clear();

    // ring should be visible for the collapse animation
    setCollapsing(true);
    setExpanded(true);

    timeoutRef.current = setTimeout(() => {
      // only collapse if this step is STILL active
      if (activeStepRef.current === stepIndex) {
        setExpanded(false);
        setCollapsing(false);
      }
    }, ANIM_MS);
  };

  const expandRing = () => {
    clear();

    // keep ring visible during expand transition
    setExpanded(true);
    setCollapsing(true);

    timeoutRef.current = setTimeout(() => {
      // only finish expand if this step is STILL inactive
      if (activeStepRef.current !== stepIndex) {
        setExpanded(true);
        setCollapsing(false);
      }
    }, ANIM_MS);
  };

  useEffect(() => {
    if (stepIndex === activeStepIndex) {
      collapseRing();
    } else {
      expandRing();
    }

    return clear;
    // stepIndex is stable per component instance, but it's fine to include it
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStepIndex, stepIndex]);

  return {expanded, collapsing};
};

export default useExpandCollapseLogic;
